const MODULE_NAME = 'colFilter';

class ColFilterController {

}

export default angular.module(MODULE_NAME, [])
	.controller('colFilterController', ColFilterController).name;



// WEBPACK FOOTER //
// ./source/modules/filter/colFilter.js